import React from 'react';
import { useIntl } from 'react-intl';

function formatApiDate(value, locale) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) {
    return '';
  }

  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  return new Intl.DateTimeFormat(locale || 'ro', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
    year: 'numeric'
  }).format(date);
}

function formatApiPeriod(period, locale) {
  if (!period || !period.date_from || !period.date_to) {
    return '';
  }

  const from = formatApiDate(period.date_from, locale);
  const to = formatApiDate(period.date_to, locale);
  return from && to ? `${from} – ${to}` : '';
}

function ReportPeriodContext({ hidden = false, meta }) {
  const intl = useIntl();
  const currentPeriod = formatApiPeriod(meta && meta.period, intl.locale);
  const comparisonPeriod = formatApiPeriod(meta && meta.comparison_period, intl.locale);

  if (hidden || !currentPeriod) {
    return null;
  }

  return (
    <aside
      aria-label={intl.formatMessage({ id: 'components.pages.reports.periodContext.label' })}
      className="report-period-context"
      data-testid="report-period-context"
    >
      <span>
        <strong>{intl.formatMessage({ id: 'components.pages.reports.periodContext.current' })}:</strong>
        {' '}{currentPeriod}
      </span>
      {comparisonPeriod && (
        <>
          <span aria-hidden="true" className="report-period-context__separator">|</span>
          <span>
            <strong>{intl.formatMessage({ id: 'components.pages.reports.periodContext.previous' })}:</strong>
            {' '}{comparisonPeriod}
          </span>
        </>
      )}
    </aside>
  );
}

export { formatApiDate, formatApiPeriod, ReportPeriodContext };
